import { render, staticRenderFns } from "./OlliPayStd.vue?vue&type=template&id=d1213bb0&scoped=true"
import script from "./OlliPayStd.vue?vue&type=script&lang=js"
export * from "./OlliPayStd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1213bb0",
  null
  
)

export default component.exports